module.exports = __webpack_public_path__ + "static/media/reddit.3e52e642.png";